import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SetInitialStateFacade } from '../../../../../common';
import { MasterDataType } from '../constants';
import { MasterDataDownloadFile, MasterDataFileInitialState, MasterDataUploadFile } from './master-data-file.actions';
import { MasterDataFileState, MasterDataFileStateModel } from './master-data-file.state';

@Injectable({ providedIn: 'root' })
export class MasterDataFileFacade implements SetInitialStateFacade {
  masterDataFileState$: Observable<MasterDataFileStateModel> = this.store.select(MasterDataFileState.getState);
  loaded$: Observable<boolean> = this.store.select(MasterDataFileState.getLoaded);

  constructor(private store: Store) {}

  uploadMasterDataFile(type: MasterDataType, file: File): void {
    this.store.dispatch(new MasterDataUploadFile({ type, file }));
  }

  downloadMasterDataFile(type: MasterDataType): void {
    this.store.dispatch(new MasterDataDownloadFile(type));
  }

  setInitialState(): void {
    this.store.dispatch(new MasterDataFileInitialState());
  }
}
